import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleQueFaireApresCyberattaque() {
  return (
    <BlogArticleLayout
      tag="Cybersécurité"
      title="Que faire après une cyberattaque : la marche à suivre"
      date="20 octobre 2026"
      ctaTitle="Préparez votre entreprise avant qu'un incident survienne"
      ctaText="Le diagnostic vérifie si vous disposez déjà d'une procédure de réponse à incident, et vous aide à en construire une si ce n'est pas le cas."
    >
      <p style={s.intro}>
        Une cyberattaque n'annonce jamais son arrivée. Ce qui distingue un incident maîtrisé d'une véritable
        crise n'est pas la gravité initiale de l'attaque, mais la qualité de la réaction dans les premières
        heures.
      </p>

      <h2 style={s.h2}>Les premiers réflexes</h2>
      <p>
        Isolez les systèmes touchés du réseau pour limiter la propagation, sans forcément les éteindre
        brutalement si cela peut détruire des preuves utiles à l'analyse. Alertez immédiatement votre référent
        interne ou votre prestataire informatique. Ne payez pas de rançon dans la précipitation : prenez le
        temps d'évaluer la situation avec les bons interlocuteurs.
      </p>

      <h2 style={s.h2}>Vos obligations de notification</h2>
      <p>
        Si des données personnelles sont concernées, une notification à la CNIL est requise sous 72 heures
        dès lors qu'un risque existe pour les personnes concernées — voir notre article
        {' '}<Link to="/blog/violation-donnees-personnelles-obligations-procedure" style={s.link}>sur la violation de données personnelles</Link>{' '}
        pour la procédure complète. Si votre entreprise est concernée par NIS2, une déclaration aux autorités
        compétentes peut également être requise, selon un calendrier différent et plus resserré.
      </p>

      <h2 style={s.h2}>Communiquer, sans sur-communiquer ni minimiser</h2>
      <p>
        Selon la nature de l'incident, une communication mesurée vers vos clients, salariés ou partenaires
        peut être nécessaire — en particulier si leurs données ou leur activité sont directement impactées.
        L'objectif est la transparence sur les faits et les mesures prises, sans spéculation sur des éléments
        encore incertains.
      </p>

      <h2 style={s.h2}>Après l'urgence : comprendre ce qui s'est passé</h2>
      <p>
        Une fois la situation stabilisée, une analyse des causes permet d'identifier la faille exploitée et
        d'éviter qu'elle ne se reproduise. C'est aussi le moment de mettre à jour votre évaluation des risques
        — voir notre
        {' '}<Link to="/blog/gestion-des-risques-cybersecurite-methode-commune" style={s.link}>article sur la gestion des risques</Link>{' '}
        — plutôt que de se contenter de corriger le symptôme immédiat.
      </p>

      <h2 style={s.h2}>Le meilleur moment pour préparer cette réponse : avant l'incident</h2>
      <p>
        Une procédure écrite, même courte, qui précise qui prévenir et dans quel ordre, fait gagner un temps
        précieux le jour où un incident survient réellement. C'est un des points vérifiés dans notre
        {' '}<Link to="/blog/checklist-cybersecurite-entreprise" style={s.link}>checklist cybersécurité entreprise</Link>.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleQueFaireApresCyberattaque;
